<template>
  <div v-if="checklistItems.length">
    <template v-for="item in checklistItems">
      <VerificationChecklistItem
        :key="item.checklistItemDetails.id"
        :checklist-item="item"
        class="mb-3"
      />
    </template>
    
    <VerificationIdentityChecklistItem
      v-if="identityCheck.id"
      :checklist-item="identityCheck"
      class="mb-3"
    />
  </div>
</template>
<script>
import VerificationChecklistItem from './VerificationChecklistItem.vue'
import VerificationIdentityChecklistItem from './VerificationIdentityChecklistItem.vue'

export default {
  name: 'VerificationChecklist',

  components: {
    VerificationChecklistItem,
    VerificationIdentityChecklistItem,
  },

  props: {
    checklistItems: {
      type: Array,
      required: true,
      default: () => []
    },

    identityCheck: {
      type: Object,
      default() {
        return {}
      }
    }
  },
}
</script>
<style lang="">
  
</style>